import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

const cardStyle = ({ theme }) => css`
  width: 100%;
  padding: ${theme.spacings.mega};
  background: ${theme.colors.white};
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);

  ${theme.media.mega} {
    padding: ${theme.spacings.tera} ${theme.spacings.mega};
  }
`

const Card = styled('div')(cardStyle)

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Card
